<template>
  <div class="pagination">
    <el-pagination :total="item"
                   :page-size="1" 
                   background
                   layout="prev,pager,next,jumper"
                   :prev-text="'上一页'"
                   :next-text	="'下一页'"
                   @current-change="jumpToPage"
                   @prev-click="jumpToPage"
                   @next-click="jumpToPage"
                   @size-change="jumpToPage"
    ></el-pagination>
  </div>
</template>

<script>
  export default {
    name: 'pagination',
    props: ['item'],
    methods: {
      jumpToPage(item) {
        scrollTo(0,0);
        this.$emit('clickPagination', item)
      }
    }
  }
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>